import { getRcdById } from "../../axios_with_token";
import "./Select.css";

import { useRef, useLayoutEffect, useState } from "react";

export default function Select({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    const [refreshId, setRefreshId] = useState(0);
    const refresh = _=>setRefreshId(refreshId+1);

    const options = fldDef.src?(fldDef.src.constructor==Function?fldDef.src():fldDef.src):[];
    const [dependOnOptions, setDependOnOptions] = useState(options);

    const selectRef = useRef();

    // form's {register, handleSubmit, formState:{errors}, setValue, unregister, getValues, trigger} 
    
    // [] init value
    useLayoutEffect(_=>{
        selectRef.current.value = form.getValues()[fldName];
    }, [form, fldName, refreshId]);

    // [depend select]
    const dependOn = fldDef.dependOn;
    if(dependOn){
        // dependOn
        if(!form._ww_org_setvalue){
            form._ww_org_setvalue = form.setValue;
            form._ww_setvalue_cb_pool = [];
            form.setValue = function(fldName, fldValue){
                const fnPool = form._ww_setvalue_cb_pool || [];
                fnPool.forEach(fn=>fn({fldName, fldValue, form}));

                // set depend on field
                return form._ww_org_setvalue(...arguments);
            }
        }

        form._ww_setvalue_cb_pool.push(({form, fldName:fldDependOnName})=>{
            if(fldDependOnName == dependOn.fld){
                // reset this fld to default
                form._ww_org_setvalue(fldName, fldDef.default);
                refresh();
            }
        })
    }

    const optionsDependOn = fldDef.optionsDependOn;
    if(optionsDependOn){
        // [base set]
        if(!form._ww_org_setvalue){
            form._ww_org_setvalue = form.setValue;
            form._ww_setvalue_cb_pool = [];
            form.setValue = function(fldName, fldValue){
                const fnPool = form._ww_setvalue_cb_pool || [];
                fnPool.forEach(fn=>fn({fldName, fldValue, form}));
                return form._ww_org_setvalue(...arguments);
            }
        }

        form._ww_setvalue_cb_pool.push(async ({fldName:fldDependOnName, fldValue:fldDependOnValue, form})=>{
            if(fldDependOnName == optionsDependOn.fld){
                const tblName = optionsDependOn.tbl;
                const tblRcdId = fldDependOnValue;
                const optionFld = optionsDependOn.tblFld;
                const rcd = await getRcdById(tblName, tblRcdId) || {};
                const strOptions = rcd[optionFld] || '';
                const tblFldValueFlds = optionsDependOn.tblFldValueFlds || 'id';
                const tblFldCaptionFlds = optionsDependOn.tblFldCaptionFlds || 'id';

                let options;
                try{
                    options = JSON.parse(strOptions);
                }catch(err){}


                if(options){
                    options = options.map(rcdOpt=>[tblFldValueFlds.split(',').filter(a=>a).map(optFld=>rcdOpt[optFld]).join(','), tblFldCaptionFlds.split(',').filter(a=>a).map(optFld=>rcdOpt[optFld]).join(',')])
                }else{
                    options = strOptions.split(',').filter(a=>a);
                    options = options.map(strOpt=>{
                        const arrOpt = strOpt.split('|');
                        return [arrOpt[0], arrOpt[1||arrOpt[0]]]
                    })
                }
                console.log('strOptions', strOptions, options);

                setDependOnOptions(options);
                console.log('set options.', dependOnOptions);
            }
        })
    }
    
    return <div>
        <input className="form-control"
            type="hidden"
            {...rest}
        />
        <select
            className="form-select"
            onChange={evt=>{
                form.setValue(fldName, selectRef.current.value);
            }}
            ref={selectRef}
        >
            {(optionsDependOn?dependOnOptions:options).map((optionDef,idx)=><option key={idx} value={optionDef[0]}>
                {optionDef[1]}
            </option>)}
        </select>
        {form.formState.errors[fldName] && <p className="fld-error">{form.formState.errors[fldName].message}</p>}
    </div>;
}